import React from "react";

const RadioOption = ({ name, label, value, selected, onSelect }) => {
  const isChecked = selected === value;

  return (
    <li>
      <label className="radio__label">
        <input
          type="radio"
          name={name}
          value={value}
          checked={isChecked}
          onChange={() => onSelect(value)}
          className="radioInput"
        />
        <span className="radio__text">{label}</span>
      </label>
    </li>
  );
}

export default RadioOption;
